var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "任务名称", clearable: "" },
                  model: {
                    value: _vm.searchForm.taskName,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "taskName", $$v)
                    },
                    expression: "searchForm.taskName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                  },
                  on: { change: _vm.changeTime },
                  model: {
                    value: _vm.times,
                    callback: function ($$v) {
                      _vm.times = $$v
                    },
                    expression: "times",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "250px" },
                    attrs: { clearable: "", placeholder: "请选择任务类型" },
                    model: {
                      value: _vm.searchForm.taskType,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "taskType", $$v)
                      },
                      expression: "searchForm.taskType",
                    },
                  },
                  _vm._l(_vm.typeOptions, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: {
                        label: item.taskTypeName,
                        value: String(item.id),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "250px" },
                    attrs: { clearable: "", placeholder: "状态" },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "status", $$v)
                      },
                      expression: "searchForm.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "未启用", value: "0" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "启用", value: "1" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.addAct } },
                  [_vm._v("添加任务")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              border: "",
              "element-loading-text": "数据加载中...",
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "taskName", label: "任务名称", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "主图", prop: "mainImage", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-image", {
                        staticStyle: { width: "60px", height: "60px" },
                        attrs: { src: scope.row.mainImage, fit: "cover" },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "taskTypeName",
                label: "任务类型",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(_vm.typeOptions, function (item) {
                      return scope.row.taskType == item.id
                        ? _c("div", [_vm._v(_vm._s(item.taskTypeName))])
                        : _vm._e()
                    })
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "标签", prop: "taskLabel", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "帖子类型", prop: "userScope", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.userScope == 1
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("仅员工"),
                          ])
                        : scope.row.userScope == 2
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("仅会员"),
                          ])
                        : scope.row.userScope == 3
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("全部"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "参与人数", prop: "postCount", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "任务时间",
                prop: "",
                align: "center",
                width: "300",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.validType == 2
                        ? _c("div", [_vm._v("长期活动")])
                        : _c("div", [
                            _vm._v(
                              _vm._s(scope.row.startTime) +
                                " - " +
                                _vm._s(scope.row.endTime)
                            ),
                          ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "排序",
                prop: "taskSort",
                align: "center",
                width: "120",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          step: 1,
                          value: scope.row.taskSort,
                          size: "small",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeTaskSort(scope.row, $event)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "活动状态", prop: "status", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        on: {
                          change: function ($event) {
                            return _vm.changeStatus(
                              scope.row.id,
                              scope.row.status
                            )
                          },
                        },
                        model: {
                          value: scope.row.status,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "status", $$v)
                          },
                          expression: "scope.row.status",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                fixed: "right",
                width: "250",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCopy(scope.row)
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.reviewList(scope.row)
                                },
                              },
                            },
                            [_vm._v("审核列表")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.postList(scope.row)
                                },
                              },
                            },
                            [_vm._v("帖子列表")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }